<template>
  <v-layout align-center justify-center row fill-height>
    <v-flex>
      <ValidationObserver ref="form">
        <form @submit.prevent="onSubmit">
          <v-card max-width="344" class="mx-auto">
            <v-card-title>Prihlásenie</v-card-title>
            <v-card-text>
              <ValidationProvider v-slot="{ errors }" name="E-mail" rules="email|required">
                <v-text-field
                  v-model="login.username"
                  label="E-mail"
                  type="email"
                  :error-messages="errors"
                  @keyup.enter="onSubmit"
                ></v-text-field>
              </ValidationProvider>
              <ValidationProvider v-slot="{ errors }" name="Heslo" rules="required">
                <v-text-field
                  v-model="login.password"
                  label="Heslo"
                  type="password"
                  :error-messages="errors"
                  @keyup.enter="onSubmit"
                ></v-text-field>
              </ValidationProvider>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn class="text-lg-right" color="primary" type="submit">Prihlásiť</v-btn>
            </v-card-actions>
          </v-card>
        </form>
      </ValidationObserver>
    </v-flex>
  </v-layout>
</template>

<script>
export default {
  data() {
    return {
      login: {
        username: "",
        password: ""
      }
    };
  },

  methods: {
    onSubmit() {
      this.$refs.form.validate().then(success => {
        if (!success) {
          return;
        }

        this.openGlobalLoader("Prihlasujem ...");
        this.$store
          .dispatch("login", this.login)
          .then(() => {
            this.$router.push({
              path: this.$route.query.redirect || "/"
            });
          })
          .catch(e => {
            console.error(e);
            this.openGlobalAlert("Prihlasovacie údaje sú nesprávne.", "error");
          })
          .finally(() => {
            this.closeGlobalLoader();
          });
      });
    }
  }
};
</script>